import React from 'react';
import { CreateInventoryFormPanel } from './FormLayout';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import {
    asset_status_options,
    yes_no_options,
    energy_source_type_options,
    phase_options,
    hertz_options
} from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';
import FormFieldItem from "./FormLayout";

const EyeWashStation = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    amps,
    setAmps,
    voltage,
    setVoltage,
    hertz,
    setHertz,
    phase,
    setPhase,
    systemManager,
    setSystemManager,
    hermeticallySealed,
    setHermeticallySealed,
    energySourceType,
    setEnergySourceType,
    maxDate,
}) => (
    <CreateInventoryFormPanel enabled={false}>
        <FormFieldItem>
            <Select
                required
                value={newPurchaseAquisition}
                label="Is this a new purchase / acquisition?"
               
                options={yes_no_options}
                onChange={e => setNewPurchaseAquisition(e.target.value)}
            />
        </FormFieldItem>
        <LocationDropdown
            required
            locations={locations}
            location={location}
            subLocation={subLocation}
            onChangeLocation={setLocation}
            onChangeSubLocation={setSubLocation}
           
        />
        <FormFieldItem>
            <Input
                required
                fullWidth
                label="Name"
                value={name}
                onChange={e => setName(e.target.value)}
                error={!name}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                required
                value={assetStatus}
                label="Asset Status"
               
                options={asset_status_options}
                onChange={e => setAssetStatus(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                required
                fullWidth
                label="Tag Number"
                value={tagNumber}
                onChange={e => setTagNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                required
                fullWidth
                label="Serial Number"
                value={serialNumber}
                onChange={e => setSerialNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={acquisitionDate}
                onChange={date => setAquisitionDate(date)}
                label="Acquisition Date *"
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={disbursementDate}
                onChange={date => setDisbursementDate(date)}
                label="Disbursement Date"
               
                disabled
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={installDate}
                onChange={date => setInstallDate(date)}
                label="Install Date *"
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                multiLine
                label="Location On Site"
                value={locationOnSite}
                onChange={e => setLocationOnsite(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={manufacturer}
                label="Manufacturer"
               
                options={manufacturers}
                onChange={e => setManufacturer(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={manufactureDate}
                onChange={date => setManufactureDate(date)}
                label="Manufacturer Date"
               
                maxDate={maxDate}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Model Number"
                value={modelNumber}
                onChange={e => setModelNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={modelYear}
                label="Model Year"
               
                options={years}
                onChange={e => setModelYear(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Brand"
                value={brand}
                onChange={e => setBrand(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="PO Number"
                value={poNumber}
                onChange={e => setPONumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={lifeTime}
                label="Expected Lifetime (years)"
               
                options={lifeTimeOptions}
                onChange={e => setLifeTime(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                type="number"
                label="Amps"
                value={amps}
                onChange={e => setAmps(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                required
                fullWidth
                type="number"
                label="Voltage"
                value={voltage}
                onChange={e => setVoltage(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={hertz}
                label="Hertz"
               
                options={hertz_options}
                onChange={e => setHertz(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={phase}
                label="Phase"
               
                options={phase_options}
                onChange={e => setPhase(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={systemManager}
                label="System Manager"
               
                options={phase_options}
                onChange={e => setSystemManager(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={hermeticallySealed}
                label="Is Hermetically Sealed"
               
                options={yes_no_options}
                onChange={e => setHermeticallySealed(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={energySourceType}
                label="Energy Source Type"
               
                options={energy_source_type_options}
                onChange={e => setEnergySourceType(e.target.value)}
            />
        </FormFieldItem>
    </CreateInventoryFormPanel>
);

EyeWashStation.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    system_status_options: PropTypes.array.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    amps: PropTypes.string.isRequired,
    setAmps: PropTypes.func.isRequired,
    voltage: PropTypes.string.isRequired,
    setVoltage: PropTypes.func.isRequired,
    hertz: PropTypes.string.isRequired,
    setHertz: PropTypes.func.isRequired,
    phase: PropTypes.string.isRequired,
    setPhase: PropTypes.func.isRequired,
    systemManager: PropTypes.string.isRequired,
    setSystemManager: PropTypes.func.isRequired,
    hermeticallySealed: PropTypes.string.isRequired,
    setHermeticallySealed: PropTypes.func.isRequired,
    energySourceType: PropTypes.string.isRequired,
    setEnergySourceType: PropTypes.func.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default EyeWashStation;
